module.exports = __webpack_public_path__ + "img/1x.d1eeb06.jpg";